module.exports = __webpack_public_path__ + "img/hardshell_ventral_labelled.48be1de4.jpg";